import type { ReactNode } from 'react';
import { cn } from '@localagent/ui/lib/utils';

export function PageHeaderBar({
  title,
  description,
  leading,
  adornment,
  tabs,
  actions,
  className,
  testId,
}: {
  title?: ReactNode;
  description?: ReactNode;
  leading?: ReactNode;
  adornment?: ReactNode;
  tabs?: ReactNode;
  actions?: ReactNode;
  className?: string;
  testId?: string;
}) {
  if (!leading && !title && !description && !adornment && !tabs && !actions) return null;
  return (
    <header
      className={cn('flex h-12 shrink-0 items-center gap-3 border-b bg-background px-4', className)}
      data-testid={testId}
    >
      {leading}
      {title ? <h1 className="min-w-0 max-w-[16rem] shrink-0 truncate text-body font-semibold">{title}</h1> : null}
      {description ? (
        <span
          className="min-w-0 max-w-[12rem] shrink truncate text-caption text-muted-foreground"
          data-testid="page-header-description"
        >
          {description}
        </span>
      ) : null}
      {adornment}
      {tabs ? <div className="flex h-full min-w-0 items-center">{tabs}</div> : null}
      {actions ? <div className="ml-auto flex shrink-0 items-center gap-2">{actions}</div> : null}
    </header>
  );
}
